import {Component, Input, OnInit, Output} from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss']
})
export class TextComponent implements OnInit {

  @Output()
  response = new EventEmitter();

  @Input()
  question: any;
  @Input()
  id: any;

  @Input() domain;

  public val: any;

  constructor() { }

  ngOnInit() {
  }

  clear() {
    this.val = '';
  }

  onChange() {
    this.response.emit(JSON.stringify({id: this.id, question: this.question, response: this.val, domain: this.domain}));
  }

}
